// Database marchi e modelli auto dal 1990 in poi
export const carBrands = [
  {
    brand: "Alfa Romeo",
    models: ["145", "146", "147", "155", "156", "159", "164", "166", "4C", "8C", "Brera", "Giulia", "Giulietta", "GT", "GTV", "MiTo", "Spider", "Stelvio", "Tonale"]
  },
  {
    brand: "Audi",
    models: ["80", "90", "100", "A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "e-tron", "Q2", "Q3", "Q4", "Q5", "Q7", "Q8", "R8", "RS3", "RS4", "RS5", "RS6", "RS7", "S3", "S4", "S5", "S6", "S7", "S8", "TT", "TTS"]
  },
  {
    brand: "BMW",
    models: ["Serie 1", "Serie 2", "Serie 3", "Serie 4", "Serie 5", "Serie 6", "Serie 7", "Serie 8", "i3", "i4", "i7", "i8", "iX", "iX1", "iX3", "M2", "M3", "M4", "M5", "M6", "M8", "X1", "X2", "X3", "X4", "X5", "X6", "X7", "Z3", "Z4"]
  },
  {
    brand: "Chevrolet",
    models: ["Aveo", "Camaro", "Captiva", "Corvette", "Cruze", "Epica", "Equinox", "Kalos", "Lacetti", "Malibu", "Matiz", "Nubira", "Orlando", "Spark", "Tahoe", "Trailblazer", "Trax"]
  },
  {
    brand: "Citroën",
    models: ["AX", "Berlingo", "C1", "C2", "C3", "C3 Aircross", "C3 Picasso", "C4", "C4 Cactus", "C4 Picasso", "C4 SpaceTourer", "C5", "C5 Aircross", "C5 X", "C6", "C8", "C-Crosser", "C-Elysée", "DS3", "DS4", "DS5", "Jumper", "Jumpy", "Nemo", "Saxo", "Xantia", "XM", "Xsara", "Xsara Picasso", "ZX"]
  },
  {
    brand: "Dacia",
    models: ["Dokker", "Duster", "Jogger", "Lodgy", "Logan", "Sandero", "Spring"]
  },
  {
    brand: "DS",
    models: ["DS 3", "DS 3 Crossback", "DS 4", "DS 5", "DS 7", "DS 9"]
  },
  {
    brand: "Ferrari",
    models: ["296 GTB", "348", "360", "456", "458", "488", "512", "550", "575", "599", "612", "812", "California", "Enzo", "F12", "F355", "F40", "F430", "F50", "F8", "FF", "GTC4Lusso", "LaFerrari", "Portofino", "Purosangue", "Roma", "SF90"]
  },
  {
    brand: "Fiat",
    models: ["124 Spider", "500", "500C", "500L", "500X", "600", "Barchetta", "Bravo", "Brava", "Cinquecento", "Coupé", "Croma", "Doblò", "Ducato", "Fiorino", "Freemont", "Grande Punto", "Idea", "Linea", "Marea", "Multipla", "Panda", "Punto", "Punto Evo", "Qubo", "Scudo", "Sedici", "Seicento", "Stilo", "Strada", "Talento", "Tempra", "Tipo", "Ulysse", "Uno"]
  },
  {
    brand: "Ford",
    models: ["B-Max", "C-Max", "Cougar", "EcoSport", "Edge", "Escort", "Explorer", "Fiesta", "Focus", "Fusion", "Galaxy", "Ka", "Ka+", "Kuga", "Maverick", "Mondeo", "Mustang", "Mustang Mach-E", "Orion", "Probe", "Puma", "Ranger", "S-Max", "Sierra", "Tourneo", "Transit", "Transit Connect", "Transit Custom"]
  },
  {
    brand: "Honda",
    models: ["Accord", "City", "Civic", "CR-V", "CR-Z", "e", "FR-V", "HR-V", "Insight", "Jazz", "Legend", "NSX", "Prelude", "S2000", "Stream"]
  },
  {
    brand: "Hyundai",
    models: ["Accent", "Atos", "Bayon", "Coupé", "Elantra", "Galloper", "Genesis", "Getz", "Grand Santa Fe", "i10", "i20", "i30", "i40", "Ioniq", "Ioniq 5", "Ioniq 6", "ix20", "ix35", "ix55", "Kona", "Lantra", "Matrix", "Nexo", "Pony", "Santa Fe", "Sonata", "Terracan", "Trajet", "Tucson", "Veloster", "XG"]
  },
  {
    brand: "Jaguar",
    models: ["E-Pace", "F-Pace", "F-Type", "I-Pace", "S-Type", "X-Type", "XE", "XF", "XJ", "XK", "XKR"]
  },
  {
    brand: "Jeep",
    models: ["Avenger", "Cherokee", "Commander", "Compass", "Gladiator", "Grand Cherokee", "Patriot", "Renegade", "Wrangler"]
  },
  {
    brand: "Kia",
    models: ["Carens", "Carnival", "Ceed", "Cerato", "e-Niro", "EV6", "Magentis", "Niro", "Opirus", "Optima", "Picanto", "Pro Ceed", "Rio", "Shuma", "Sorento", "Soul", "Sportage", "Stinger", "Stonic", "Venga", "XCeed"]
  },
  {
    brand: "Lamborghini",
    models: ["Aventador", "Countach", "Diablo", "Gallardo", "Huracán", "Murciélago", "Revuelto", "Urus"]
  },
  {
    brand: "Lancia",
    models: ["Beta", "Dedra", "Delta", "Kappa", "Lybra", "Musa", "Phedra", "Prisma", "Thema", "Thesis", "Y", "Ypsilon", "Zeta"]
  },
  {
    brand: "Land Rover",
    models: ["Defender", "Discovery", "Discovery Sport", "Freelander", "Range Rover", "Range Rover Evoque", "Range Rover Sport", "Range Rover Velar"]
  },
  {
    brand: "Lexus",
    models: ["CT", "ES", "GS", "GX", "IS", "LC", "LFA", "LS", "LX", "NX", "RC", "RX", "SC", "UX"]
  },
  {
    brand: "Maserati",
    models: ["3200 GT", "Ghibli", "GranCabrio", "Grancala", "GranSport", "GranTurismo", "Grecale", "Levante", "MC20", "Quattroporte", "Shamal", "Spyder"]
  },
  {
    brand: "Mazda",
    models: ["121", "2", "3", "323", "5", "6", "626", "BT-50", "CX-3", "CX-30", "CX-5", "CX-60", "CX-7", "CX-9", "Demio", "MPV", "MX-3", "MX-30", "MX-5", "MX-6", "Premacy", "RX-7", "RX-8", "Tribute", "Xedos"]
  },
  {
    brand: "Mercedes-Benz",
    models: ["Classe A", "Classe B", "Classe C", "Classe CL", "Classe CLA", "Classe CLC", "Classe CLK", "Classe CLS", "Classe E", "Classe G", "Classe GL", "Classe GLA", "Classe GLB", "Classe GLC", "Classe GLE", "Classe GLK", "Classe GLS", "Classe M", "Classe R", "Classe S", "Classe SL", "Classe SLC", "Classe SLK", "Classe SLR", "Classe SLS", "Classe V", "EQA", "EQB", "EQC", "EQE", "EQS", "EQV", "Maybach", "Sprinter", "Viano", "Vito"]
  },
  {
    brand: "Mini",
    models: ["Cabrio", "Clubman", "Countryman", "Coupé", "Hatch", "One", "Paceman", "Roadster"]
  },
  {
    brand: "Mitsubishi",
    models: ["3000 GT", "ASX", "Carisma", "Colt", "Eclipse", "Eclipse Cross", "Galant", "Grandis", "i-MiEV", "L200", "Lancer", "Outlander", "Pajero", "Pajero Pinin", "Pajero Sport", "Space Runner", "Space Star", "Space Wagon"]
  },
  {
    brand: "Nissan",
    models: ["100NX", "200SX", "350Z", "370Z", "Almera", "Almera Tino", "Ariya", "Cube", "e-NV200", "GT-R", "Juke", "Leaf", "Maxima", "Micra", "Murano", "Navara", "Note", "NV200", "NV300", "Pathfinder", "Patrol", "Pixo", "Primastar", "Primera", "Pulsar", "Qashqai", "Serena", "Sunny", "Terrano", "Tiida", "X-Trail"]
  },
  {
    brand: "Opel",
    models: ["Adam", "Agila", "Ampera", "Antara", "Astra", "Calibra", "Campo", "Cascada", "Combo", "Corsa", "Crossland", "Frontera", "Grandland", "GT", "Insignia", "Karl", "Meriva", "Mokka", "Monterey", "Movano", "Omega", "Senator", "Signum", "Sintra", "Speedster", "Tigra", "Vectra", "Vivaro", "Zafira"]
  },
  {
    brand: "Peugeot",
    models: ["1007", "106", "107", "108", "2008", "205", "206", "206+", "207", "208", "3008", "301", "306", "307", "308", "309", "4007", "4008", "405", "406", "407", "408", "5008", "508", "605", "607", "806", "807", "Bipper", "Boxer", "Expert", "iOn", "Partner", "RCZ", "Rifter", "Traveller"]
  },
  {
    brand: "Porsche",
    models: ["718 Boxster", "718 Cayman", "911", "918", "924", "928", "944", "968", "Boxster", "Cayenne", "Cayman", "Macan", "Panamera", "Taycan"]
  },
  {
    brand: "Renault",
    models: ["4", "5", "11", "19", "21", "25", "Arkana", "Austral", "Avantime", "Captur", "Clio", "Espace", "Express", "Fluence", "Grand Espace", "Grand Modus", "Grand Scenic", "Kadjar", "Kangoo", "Koleos", "Laguna", "Latitude", "Master", "Megane", "Modus", "R19", "Safrane", "Scenic", "Symbol", "Talisman", "Thalia", "Trafic", "Twingo", "Twizy", "Vel Satis", "Wind", "Zoe"]
  },
  {
    brand: "Seat",
    models: ["Alhambra", "Altea", "Arona", "Arosa", "Ateca", "Cordoba", "Exeo", "Ibiza", "Inca", "Leon", "Malaga", "Marbella", "Mii", "Tarraco", "Terra", "Toledo"]
  },
  {
    brand: "Skoda",
    models: ["Citigo", "Enyaq", "Fabia", "Favorit", "Felicia", "Forman", "Kamiq", "Karoq", "Kodiaq", "Octavia", "Praktik", "Rapid", "Roomster", "Scala", "Superb", "Yeti"]
  },
  {
    brand: "Smart",
    models: ["Forfour", "Fortwo", "Roadster"]
  },
  {
    brand: "Subaru",
    models: ["BRZ", "Forester", "Impreza", "Justy", "Legacy", "Levorg", "Outback", "SVX", "Tribeca", "WRX", "XV"]
  },
  {
    brand: "Suzuki",
    models: ["Across", "Alto", "Baleno", "Cappuccino", "Carry", "Celerio", "Grand Vitara", "Ignis", "Jimny", "Kizashi", "Liana", "S-Cross", "Samurai", "SJ", "Splash", "Swace", "Swift", "SX4", "Vitara", "Wagon R+", "X-90"]
  },
  {
    brand: "Tesla",
    models: ["Model 3", "Model S", "Model X", "Model Y", "Roadster"]
  },
  {
    brand: "Toyota",
    models: ["4Runner", "Auris", "Avalon", "Avensis", "Aygo", "bZ4X", "C-HR", "Camry", "Carina", "Celica", "Corolla", "Corolla Cross", "Corolla Verso", "Crown", "FJ Cruiser", "GT86", "GR86", "GR Supra", "GR Yaris", "Highlander", "Hilux", "iQ", "Land Cruiser", "MR2", "Paseo", "Picnic", "Previa", "Prius", "Prius+", "ProAce", "RAV4", "Sequoia", "Starlet", "Supra", "Tercel", "Urban Cruiser", "Verso", "Verso-S", "Yaris", "Yaris Cross"]
  },
  {
    brand: "Volkswagen",
    models: ["Amarok", "Arteon", "Beetle", "Bora", "Caddy", "California", "Caravelle", "CC", "Corrado", "Crafter", "CrossGolf", "CrossPolo", "CrossTouran", "e-Golf", "e-Up", "Eos", "Fox", "Golf", "Golf Plus", "Golf Sportsvan", "ID.3", "ID.4", "ID.5", "ID.Buzz", "Jetta", "Lupo", "Multivan", "New Beetle", "Passat", "Phaeton", "Polo", "Scirocco", "Sharan", "T-Cross", "T-Roc", "Taigo", "Tiguan", "Tiguan Allspace", "Touareg", "Touran", "Transporter", "Up", "Vento"]
  },
  {
    brand: "Volvo",
    models: ["240", "340", "440", "460", "480", "740", "760", "850", "940", "960", "C30", "C40", "C70", "EX30", "EX90", "S40", "S60", "S70", "S80", "S90", "V40", "V50", "V60", "V70", "V90", "XC40", "XC60", "XC70", "XC90"]
  }
];

// Funzione per ottenere tutti i marchi
export const getAllBrands = () => carBrands.map(b => b.brand).sort();

// Funzione per ottenere i modelli di un marchio
export const getModelsByBrand = (brand) => {
  const found = carBrands.find(b => b.brand.toLowerCase() === brand.toLowerCase());
  return found ? found.models.sort() : [];
};

export default carBrands;
